import { toast } from 'sonner';
import i18next from 'i18next';
import { useBigdesMeasureStore } from '@/store/bigdes-measure.store.js';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class BigdesMeasureIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    _getErrorMessage(error) {
        return getIntegrationErrorMessage(error);
    }

    async fetchAll(params = {}) {
        const store = useBigdesMeasureStore.getState();
        store.setLoading(true);
        store.clearError();

        try {
            const merged = { ...store.searchParams, ...params };
            const response = await this.service.getAll({
                page: merged.page,
                pageSize: merged.pageSize,
                search: merged.search || undefined,
                sortBy: merged.sortBy,
                sortOrder: merged.sortOrder,
            });

            store.setItems(response.data || []);
            if (response.pagination) {
                store.setPaginationData({
                    total: response.pagination.total ?? 0,
                    totalPages: response.pagination.totalPages ?? 1,
                    page: response.pagination.page ?? merged.page,
                    pageSize: response.pagination.pageSize ?? merged.pageSize,
                });
            }
            if (response.uniqueValues) {
                store.setUniqueValues(response.uniqueValues);
            }

            return {
                success: true,
                data: response.data,
                pagination: response.pagination,
            };
        } catch (error) {
            const message = this._getErrorMessage(error);
            store.setError(message);
            toast.error(message);
            return { success: false, error: message };
        } finally {
            store.setLoading(false);
        }
    }
}
